import { useMemo } from 'react'

// eslint-disable-next-line  arrow-body-style
export const useConst = <T>(initialStateGetter: () => T) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(initialStateGetter, [])
}
